import { createFileRoute } from '@tanstack/react-router'
import { videoRepository } from '@/data/adapters/api/video.api'
import { useAppStore } from '@/stores/app.store'

export interface VideosPageSearch {
  tab?: 'overview' | 'videos' | 'live'
}

const TAB_VALUES = ['overview', 'videos', 'live'] as const
type VideosTab = (typeof TAB_VALUES)[number]

function isVideosTab(value: unknown): value is VideosTab {
  return typeof value === 'string' && (TAB_VALUES as readonly string[]).includes(value)
}

export const Route = createFileRoute('/$orgSlug/$clientSlug/videos')({
  validateSearch: (search: Record<string, unknown>): VideosPageSearch => ({
    tab: isVideosTab(search.tab) ? search.tab : undefined,
  }),
  // Prefetch the range the page will actually request. A hardcoded window
  // fires a query whose key never matches the page's, wasting a round trip.
  loader: ({ context: { queryClient, client } }) => {
    const range = useAppStore.getState().dateRange
    return queryClient.ensureQueryData({
      queryKey: ['video', 'daily', client.id, range.from.toISOString(), range.to.toISOString()],
      queryFn: () => videoRepository.getDailyMetrics(client.id, range),
    })
  },
})
